export default () => (
  <svg
    width="7"
    height="4"
    viewBox="0 0 7 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.20711 0C0.761654 0 0.538571 0.538571 0.853553 0.853553L3.14645 3.14645C3.34171 3.34171 3.65829 3.34171 3.85355 3.14645L6.14645 0.853553C6.46143 0.53857 6.23835 0 5.79289 0H1.20711Z"
      fill="currentColor"
    />
  </svg>
);
